import type { ArgoCDApplicationResource, ProjectResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ExpandingChipList } from "~/areas/infrastructure/components/ArgoCDInstances/components/ExpandingChipList";
import { projectChipList } from "~/components/Chips";
type ArgoCDApplicationProjectsChipListProps = {
    application: ArgoCDApplicationResource;
    projects: ProjectResource[];
};
export const ArgoCDApplicationProjectsChipList = (props: ArgoCDApplicationProjectsChipListProps) => {
    const projectIds = [...new Set(props.application.Sources.map((src) => src.ProjectId).filter((id) => id !== null))];
    return <ExpandingChipList singularName={"project"} ids={projectIds} renderChipList={(ids) => projectChipList(props.projects, ids)}/>;
};
